import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { ScrollComponent } from '../../../../common/scrollComponent'
import { selectCompanyInfo } from '../../header/companyInfo/store/slice'
import classes from './index.module.scss'
import {
  addPanel,
  selectCompanyTypeTemplate,
  selectPanelById,
  selectPanelId,
} from './store/slice'

const PanelList = ({ getPanels, formatDefaultPanel }) => {
  const dispatch = useDispatch()

  const panelId = useSelector(selectPanelId)
  const panelById = useSelector(selectPanelById)
  const companyInfo = useSelector(selectCompanyInfo)
  const companyTypeTemplate = useSelector(selectCompanyTypeTemplate)

  const companyType = companyTypeTemplate || companyInfo.companyType

  return (
    <div className={classes.panelList}>
      <Element
        style={{ fontSize: 14, color: '#191D25' }}
        className={classes.title}
      >
        <Translate value="preferenceSetting.PANEL_LIST" />
      </Element>
      <div className={classes.note}>
        <Translate value="preferenceSetting.PANEL_LIST_NOTE" />
      </div>
      <div className={classes.items}>
        <ScrollComponent>
          {getPanels(companyType).map((panel) => {
            const count = panelId.reduce((total, id) => {
              if (panelById[id]?.key === panel?.key) {
                total += 1
              }
              return total
            }, 0)

            return (
              <div key={panel.key} className={classes.item}>
                <div className={`w100 ${classes.name}`}>
                  <Translate value={panel.label || ''} />
                </div>
                <div className="dFlex alignItemsCenter">
                  <span className={classes.count}>({count})</span>
                  <Icon
                    onClick={() =>
                      dispatch(
                        addPanel(
                          formatDefaultPanel
                            ? formatDefaultPanel(panel)
                            : panel,
                        ),
                      )
                    }
                    style={{ color: '#2C73E8', fontSize: 16 }}
                    className="icon-plus-circle-fill"
                  />
                </div>
              </div>
            )
          })}
        </ScrollComponent>
      </div>
    </div>
  )
}

export default PanelList
